import {
  AppBar,
  Grid,
  Toolbar,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../Assets/Images/logo.png";
import { getFooterPageMobileSideAction } from "../../../Redux/Actions/FooterPageAction";
import { Box } from "@mui/system";
import parse from "html-react-parser";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const MobileSideFooterPage = () => {
  const dispatch = useDispatch();
  //state
  const [data, setData] = useState({});
  const [expanded, setExpanded] = React.useState(false);

  //reducer data
  const { FooterPageMobileData } = useSelector((state) => state.FooterPage);

  //action called for data
  useEffect(() => {
    dispatch(getFooterPageMobileSideAction());
  }, [window.location.pathname]);

  //set data as appropriate page open
  useEffect(() => {
    if (Object.keys(FooterPageMobileData).length >= 1) {
      switch (window.location.pathname) {
        case "/privacy-policy":
          setData(FooterPageMobileData.PRIVACY_POLICY);
          break;
        case "/terms-and-conditions":
          setData(FooterPageMobileData.TERMS_CONDITIONS);
          break;
        case "/cookie-policy":
          setData(FooterPageMobileData.COOKIE_POLICY);
          break;
        case "/faq":
          setData(FooterPageMobileData.FAQ);
          break;
        default:
          setData({});
          break;
      }
    }
  }, [FooterPageMobileData]);

  //function (handle expand)
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      {window.location.pathname !== "/faq" ? (
        <>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static" sx={{ backgroundColor: "#51B6FC" }}>
              <Toolbar sx={{ minHeight: "80px !IMPORTANT" }}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  <img src={logo} style={{ height: "30px" }} />
                </Typography>
              </Toolbar>
            </AppBar>
          </Box>
          <Box sx={{ margin: "20px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box sx={{ mt: 5, mb: 5 }}>
                <Typography sx={{ fontSize: "24px" }} gutterBottom>
                  {data?.name}
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box
                sx={{
                  mt: 5,
                  mb: 5,
                  display: "justify",
                }}
              >
                <Typography sx={{ lineHeight: 2 }} gutterBottom>
                  {parse(data.description || "")}
                </Typography>
              </Box>
            </Grid>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static" sx={{ backgroundColor: "#51B6FC" }}>
              <Toolbar sx={{ minHeight: "80px !IMPORTANT" }}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  <img src={logo} style={{ height: "30px" }} />
                </Typography>
              </Toolbar>
            </AppBar>
          </Box>
          <Box sx={{ margin: "40px 30px" }}>
            <Typography sx={{ fontSize: "24px" }} gutterBottom>
              FAQ
            </Typography>
          </Box>
          <Box></Box>
          {data.length >= 1 &&
            data?.map((item, index) => {
              return (
                <>
                  <Box sx={{ margin: "20px" }}>
                    <Accordion
                      expanded={expanded === `panel${index + 1}`}
                      onChange={handleChange(`panel${index + 1}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          {item.title}
                        </Typography>
                        {/* <Typography sx={{ color: "text.secondary" }}>
                          I am an accordion
                        </Typography> */}
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>{parse(item.description || "")}</Typography>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </>
              );
            })}
        </>
      )}
    </>
  );
};

export default MobileSideFooterPage;
